interface SummaryCardsProps {
  newCount: number;
  duplicateCount: number;
  errorCount: number;
  newCategoryCount: number;
}

export const SummaryCards: React.FC<SummaryCardsProps> = ({
  newCount,
  duplicateCount,
  errorCount,
  newCategoryCount,
}) => {
  const cards = [
    { label: '新規追加', value: newCount, bg: 'bg-blue-50', text: 'text-blue-600' },
    { label: '重複あり', value: duplicateCount, bg: 'bg-yellow-50', text: 'text-yellow-600' },
    { label: 'エラー', value: errorCount, bg: 'bg-red-50', text: 'text-red-600' },
    { label: '新規カテゴリ', value: newCategoryCount, bg: 'bg-green-50', text: 'text-green-600' },
  ];

  return (
    <div className="grid grid-cols-4 gap-3">
      {cards.map((card) => (
        <div key={card.label} className={`rounded-lg ${card.bg} p-3 text-center`}>
          <div className={`text-2xl font-bold ${card.text}`}>{card.value}</div>
          <div className="text-xs text-gray-500">{card.label}</div>
        </div>
      ))}
    </div>
  );
};
